import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { selectOrganicMatterReport } from '../advice/store/selectors';
import { SiteState } from '../shared/models';

@Component({
  selector: 'app-organic-matter-quick-view',
  templateUrl: './organic-matter-quick-view.component.html',
  standalone: false,
})
export class OrganicMatterQuickViewComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);

  organicMatterBalance = 0;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  ngOnInit() {
    this.store
      .pipe(select(selectOrganicMatterReport), takeUntil(this.destroyed$))
      .subscribe(
        (report) => (this.organicMatterBalance = !report ? 0 : report.totals.organicMatterBalance),
      );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
